import { Component } from '@angular/core';
import * as PdfJs from 'pdfjs-dist';
import { UserService } from './_services/user.service';
import { UpdateService } from './_services/update.service';
import { AppService } from './_services/app.service';
import { AuthService } from './_services/auth.service';
import { AppInsightService } from './_services/app-insight.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ebol-app';
  sessionId = null;
  showHeader: boolean = false;
  showDriverHeader: boolean = false;
  alive = true;

  constructor(
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private userService: UserService, 
    private authService: AuthService, 
    private appService: AppService, 
    private appInsightsService: AppInsightService,
    //private sw: UpdateService
    ) {
    // Configure pdfjs worker for both direct usage and ng2-pdf-viewer (each has its own pdfjs instance)
    PdfJs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
    (window as any).pdfWorkerSrc = '/pdf.worker.min.mjs';
    //this.sw.checkForUpdates();
    this.userService.checkLanguage();
    this.setGoogleAnalytics();
  }

  /*ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeader = !!this.activatedRoute.firstChild.snapshot.data.showHeader;
        this.showDriverHeader = !!this.activatedRoute.firstChild.snapshot.data.showDriverHeader;
      }
    });
    
    if (!this.appService.inPortal() && this.authService.currentUserValue?.['exp']) {
      this.sessionId = setInterval(() => {
        if (this.authService.checkUserSession()) this.authService.refreshToken();
      }, 60000);
    }
  }*/

  async ngOnInit() {
     // Handle redirect/popup callbacks
    //await firstValueFrom(this.msalService.handleRedirectObservable());

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeader = !!this.activatedRoute.firstChild.snapshot.data.showHeader;
        this.showDriverHeader = !!this.activatedRoute.firstChild.snapshot.data.showDriverHeader;
      }
    });

    if (!this.appService.inPortal() && this.authService.currentUserValue?.['exp']) {
     this.authService.verifyAndRenewToken().then(async (isValidToken) => {
        if (isValidToken) {
          //console.log("token valido", isValidToken);
        }
      });
    }
  }

  ngOnDestroy() {
    this.alive = false;
    this.authService.terminateTokenRefreshWorker();
  }

  private setGoogleAnalytics() : void
  {
    const region = this.appService.getCurrentRegion();
    let trackingID = environment.googleAnalytics[`trackingId_${region}`];

    if (trackingID) {
      // register google tag manager
      const gTagManagerScript = document.createElement('script');
      gTagManagerScript.async = true;
      gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingID}`;
      document.head.appendChild(gTagManagerScript);

      // register google analytics
      const gaScript = document.createElement('script');
      gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', '${trackingID}');
      `;
      document.head.appendChild(gaScript);
    }  
  }
}
